// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "feature_flag.proto" (syntax proto3)
// tslint:disable
import { FeatureFlagService } from "./feature_flag";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service FeatureFlagService
 */
export class FeatureFlagServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = FeatureFlagService.typeName;
        this.methods = FeatureFlagService.methods;
        this.options = FeatureFlagService.options;
    }
    /**
     * Every row with its owners, retired rows included, plus the backend
     * registry. Same response for every caller.
     *
     * @generated from protobuf rpc: ListFlags
     */
    listFlags(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * FeatureFlagAdmin, or one of the flag's owners.
     *
     * @generated from protobuf rpc: SetFlag
     */
    setFlag(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * FeatureFlagAdmin, or one of the flag's owners. Holds an on flag past its
     * cleanup date.
     *
     * @generated from protobuf rpc: KeepFlag
     */
    keepFlag(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * FeatureFlagAdmin only. Replaces the flag's owner list.
     *
     * @generated from protobuf rpc: SetFlagOwners
     */
    setFlagOwners(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * FeatureFlagAdmin, or one of the flag's owners. History for the drawer.
     *
     * @generated from protobuf rpc: ListFlagChanges
     */
    listFlagChanges(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
